import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowDetailsDear', {
    endStepBubbleText: 'Authorise in Cin7 Core',
    endStepDescription: 'Approved {pluralTemplateName} will be automatically marked as "Authorised" in Cin7 Core',
});
